import {BorderSideRestDto, ColorSolidRestDto} from "@/api/pharma-cms-content-page/models";
import {BorderStyleEnum} from "@/api/enums/border-style-enum";
import {ColorSolidRestDtoModel} from "@/models/api/ColorSolidRestDtoModel";

export class BorderSideRestDtoModel implements BorderSideRestDto {
    style_code?: BorderStyleEnum | null;
    width_in_px?: number | null;
    color?: ColorSolidRestDto | null;

    static createWithDefaults(): BorderSideRestDtoModel {
        const model: BorderSideRestDtoModel = new this();
        model.color = ColorSolidRestDtoModel.createWithDefaults();
        return model;
    }

    static cloneFrom(source: BorderSideRestDto): BorderSideRestDtoModel {
        const clone: BorderSideRestDtoModel = new this();

        clone.style_code = source.style_code;
        clone.width_in_px = source.width_in_px;
        clone.color = (source.color)
            ? ColorSolidRestDtoModel.cloneFrom(source.color)
            : ColorSolidRestDtoModel.createWithDefaults();

        return clone;
    }

    /**
     * Nothing has been filled in on this side.
     *
     * Judged on the source, not on a clone: cloneFrom() substitutes an empty colour for a missing
     * one, so every clone carries a colour object whether the side has a colour or not.
     */
    static isEmpty(source?: BorderSideRestDto | null): boolean {
        if (!source) {
            return true;
        }

        return !source.style_code
            && (source.width_in_px === null || source.width_in_px === undefined)
            && ColorSolidRestDtoModel.isEmpty(source.color);
    }
}
